// Barrel export for feedback components
export { default as LoaderOverlay } from '../../../shared/components/feedback/LoaderOverlay/LoaderOverlay';
export { default as SyncBanner } from '../../../shared/components/feedback/SyncBanner/GlobalSyncOverlay';
export { default as GlobalErrorModal } from '../../../shared/components/feedback/GlobalErrorModal/GlobalErrorModal';

// Export types
export type { GlobalSyncOverlayProps } from '../../../shared/components/feedback/SyncBanner/GlobalSyncOverlayProps';